import { render, staticRenderFns } from "./FormaData.vue?vue&type=template&id=6e956b3f&scoped=true&"
import script from "./FormaData.vue?vue&type=script&lang=js&"
export * from "./FormaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e956b3f",
  null
  
)

export default component.exports